import { useState } from 'react';

type UseAddBundleToCartReturn = { idBeingAdded: number | null; updateIdBeingAdded: (newId: number | null) => void };

const useAddBundleToCart = (): UseAddBundleToCartReturn => {
    const [idBeingAdded, setIdBeingAdded] = useState<number | null>(null);

    const updateIdBeingAdded = (newId: number | null) => setIdBeingAdded(newId);

    return { idBeingAdded, updateIdBeingAdded };
};

export default useAddBundleToCart;
